export default __webpack_public_path__ + "static/media/whyBrokerIcon1.b5246ea0.webp";